import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";
import { Card, SectionTitle } from "../ui";
import { axisProps, tipProps } from "../charts";
import { DashboardData } from "@/lib/types";
import { fmtNum } from "@/lib/format";
import { useUI } from "@/lib/theme";

export default function Material({ data }: { data: DashboardData }) {
  const { t, loc, palette } = useUI();
  const gear = [...data.gear]
    .filter((g) => g.model_name)
    .sort((a, b) => b.km - a.km)
    .map((g) => ({
      name: g.model_name as string,
      km: g.km > 0 ? g.km : Math.round((g.total_distance ?? 0) / 1000),
      retired: g.retired,
    }));

  return (
    <div className="space-y-6">
      <Card>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <SectionTitle>{t("sec_km_zapatilla")}</SectionTitle>
          <div className="mb-3 flex gap-4 text-xs text-muted">
            <span className="flex items-center gap-1.5">
              <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ background: "#22c55e" }} />
              {t("gear_active")}
            </span>
            <span className="flex items-center gap-1.5">
              <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ background: "#7b766b" }} />
              {t("gear_retired")}
            </span>
          </div>
        </div>
        <ResponsiveContainer width="100%" height={Math.max(220, gear.length * 48)}>
          <BarChart data={gear} layout="vertical" margin={{ left: 30 }}>
            <CartesianGrid stroke={palette.grid} strokeOpacity={0.5} horizontal={false} />
            <XAxis type="number" {...axisProps(palette)} />
            <YAxis type="category" dataKey="name" {...axisProps(palette)} width={140} />
            <Tooltip
              {...tipProps(palette)}
              formatter={(v: number) => [`${fmtNum(v, 0, loc)} km`, t("gear_usage")]}
              cursor={{ fill: palette.cursor, fillOpacity: 0.08 }}
            />
            <Bar dataKey="km" radius={[0, 4, 4, 0]}>
              {gear.map((g) => (
                <Cell key={g.name} fill={g.retired ? "#7b766b" : "#22c55e"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <p className="mt-2 text-xs text-muted">{t("ref_zapatillas")}</p>
      </Card>
    </div>
  );
}
